export default [
  {
    title: '用户名称',
    dataIndex: 'userName',
    key: 'userName'
  },
  {
    title: '证件号',
    dataIndex: 'idNumber',
    key: 'idNumber'
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '员工号',
    dataIndex: 'workNumber',
    key: 'workNumber'
  },

  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
